import React, { Component } from "react";

import CommentIcon from "@mui/icons-material/Comment";
import styles from "./cmsHistory.module.scss";

class CmsHistoryCommentaryCounter extends Component {
  render() {
    const { onHandleClock, count, color = null } = this.props;

    return (
      <div className={styles.cmsHistoryCommentaryIcon} onClick={onHandleClock} style={{ color: color }}>
        <CommentIcon fontSize={"small"} /> {count}
      </div>
    );
  }
}

export default CmsHistoryCommentaryCounter;
